import React from "react";
import { useTranslation } from "react-i18next";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import classNames from "classnames";

import Banner from "../shopPage/Banner";
import BannerImages from "../../Common/BannerImages";
import LanguageTable from "../../Common/LanguageTable";
import { useSelector } from "react-redux";

export function OrderTaking() {
    const { t } = useTranslation();
    const mainColor = useSelector(
        (state: any) => state.global.infoUser.maincolor
    );
    const [activeTab, setActiveTab] = React.useState<number>(0);
    const orderTakingImagePathDesktop = React.useMemo(
        () => [
            "SiteWeb",
            "PriseCommande",
            "Default",
            "Header",
            "Image",
            "Desktop",
        ],
        []
    );
    const orderTakingImagePathMobile = React.useMemo(
        () => [
            "SiteWeb",
            "PriseCommande",
            "Default",
            "Header",
            "Image",
            "Mobile",
        ],
        []
    );

    const tabs = [
        {
            title: t("Order taking"),
            content: (
                <div className="banner-container mt-2">
                    <Banner
                        showTitle={true}
                        showDescription={false}
                        showSearch={false}
                        imagePath={[
                            "SiteWeb",
                            "PriseCommande",
                            "Default",
                            "Header",
                            "Image",
                        ]}
                    />
                    <section className="text-section">
                        <p className="image-title">{t("Image banner")}</p>
                        <div className="banner-images">
                            <BannerImages
                                dataPath={orderTakingImagePathDesktop}
                                title="Image Desktop"
                                size="1920*480 (png,jpg,jpeg ou webp)"
                            />
                            <BannerImages
                                dataPath={orderTakingImagePathMobile}
                                title="Image Mobile"
                                size="1920*480 (png,jpg,jpeg ou webp)"
                            />
                        </div>
                        <LanguageTable
                            path={[
                                "SiteWeb",
                                "PriseCommande",
                                "Default",
                                "Header",
                            ]}
                            fields={[
                                {
                                    key: "Title",
                                    label: "Titre",
                                    placeholder: "Enter the Title",
                                },
                            ]}
                            defaultTexts={{
                                Title: {
                                    AL:
                                        "Entdecke unsere Speisekarte und finde dein perfektes Gericht!",
                                    EN:
                                        "Explore our menu and find your ideal dish!",
                                    ES:
                                        "Explora nuestro menú y encuentra tu plato ideal.",
                                    FR:
                                        "Explorez notre menu et trouvez votre plat idéal !",
                                    IT:
                                        "Esplora il nostro menu e trova il tuo piatto ideale!",
                                },
                            }}
                            sectionTitle="Title"
                        />
                    </section>
                </div>
            ),
            customClassName: "",
        },
    ];

    function toggleNav(tab: number) {
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
    }

    return (
        <div className="d-flex justify-content-between">
            <div style={{ width: "100%" }}>
                <div style={{ borderBottom: "1px solid #ddd4d4" }}>
                    <Nav
                        tabs
                        style={{
                            backgroundColor: "white",
                            width: "50px",
                            display: "grid",
                            gridTemplateColumns: `repeat(${tabs.length}, 1fr)`,
                            border: "unset",
                        }}
                    >
                        {tabs.map((element, index) => (
                            <NavItem
                                key={index}
                                className={classNames(
                                    "pb-1",
                                    "d-flex align-items-center text-nowrap",
                                    {
                                        "disable-nav-item__clz":
                                            activeTab !== index,
                                    },
                                    element.customClassName
                                )}
                                style={{
                                    cursor: "pointer",
                                    borderBottom:
                                        activeTab === index
                                            ? `${mainColor} 3px solid`
                                            : "",
                                }}
                            >
                                <NavLink
                                    className={classNames("text-dark w-100", {
                                        "active customer-account-menu-nav-link-active__clz":
                                            activeTab === index,
                                        "customer-account-menu-nav-link-disable__clz":
                                            activeTab !== index,
                                    })}
                                    onClick={() => toggleNav(index)}
                                >
                                    <span
                                        className="px-2"
                                        style={{
                                            font:
                                                "normal normal 600 20px/27px Segoe UI",
                                        }}
                                    >
                                        {element.title}
                                    </span>
                                </NavLink>
                            </NavItem>
                        ))}
                    </Nav>
                </div>
                <TabContent activeTab={activeTab} className="h-100">
                    {tabs.map((element, index) => (
                        <TabPane
                            tabId={index}
                            key={index}
                            style={{ height: "90%" }}
                        >
                            {element.content}
                        </TabPane>
                    ))}
                </TabContent>
            </div>
        </div>
    );
}
